import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ApiService {

    constructor(private http: HttpClient) {}

    get(path: string, headers = {}): Observable<any> {
        return this.http.get(path,  {headers: headers} );
    }

    put(path: string, body = {}): Observable<any> {
        return this.http.put(path, body);
    }

    post(path: string, body = {}, params = {}): Observable<any> {
        return this.http.post(path, body, { params });
    }

    delete(path: string, headers = {}): Observable<any> {
        return this.http.delete(path, {headers: headers});
    }
}
